import React, { useEffect, useMemo, useState } from 'react';
import { Button, ConfirmModal, IconButton } from 'Permafrost/index';
import { StyledWizard } from './Wizard.styles';
const commonButtonProps = {
    adjustAlignment: -2,
    size: 'large',
};
export function Wizard(props) {
    const { children, className, confirmCancel, disableNextStep, disablePrevStep, disableSubmit, id, isLastStep, onCancel, onNextPress, onStepChange, onSubmit, startingStep, steps, submitButtonLabel, submitProcessing = '', wizardTitle, nextButtonProps, } = props;
    const [currentStep, setCurrentStep] = useState(startingStep || steps[0]);
    const [openCancelConfirm, setOpenCancelConfirm] = useState(false);
    const onLastStep = useMemo(() => {
        if (isLastStep !== undefined) {
            return isLastStep;
        }
        return steps.indexOf(currentStep) === steps.length - 1;
    }, [isLastStep, steps, currentStep]);
    const isBusy = !!(submitProcessing && submitProcessing.length > 0);
    const nextStep = () => {
        if (!onLastStep) {
            const currentIndex = steps.indexOf(currentStep);
            setCurrentStep(steps[currentIndex + 1]);
        }
    };
    const prevStep = () => {
        const currentIndex = steps.indexOf(currentStep);
        if (currentIndex !== 0) {
            setCurrentStep(steps[currentIndex - 1]);
        }
    };
    // handles the user's selection in the cancel confirmation modal
    const handleCancelRequest = (confirmCancel) => {
        if (confirmCancel && onCancel) {
            onCancel();
        }
        setOpenCancelConfirm(false);
    };
    const handleNextPress = () => {
        const allowNext = onNextPress ? onNextPress() : true;
        if (!allowNext) {
            return;
        }
        if (onLastStep) {
            handleSubmit();
        }
        else {
            nextStep();
        }
    };
    const handleSubmit = () => {
        onSubmit();
    };
    // report current step to the consuming component
    useEffect(() => {
        onStepChange(currentStep);
    }, [currentStep]);
    // ensures `currentStep` is reset on unmount, just in case
    useEffect(() => {
        return () => setCurrentStep(steps[0] || '');
    }, []);
    return (React.createElement(StyledWizard, { className: className, "data-cy": props['data-cy'], id: id },
        React.createElement("nav", null,
            React.createElement("h1", null,
                wizardTitle,
                ": ",
                currentStep),
            React.createElement("div", { className: "wizard-buttons" },
                React.createElement(Button, { onClick: () => setOpenCancelConfirm(true), variant: "link-style" }, "Cancel"),
                steps.indexOf(currentStep) !== 0 && (React.createElement(IconButton, Object.assign({}, commonButtonProps, { iconName: "fa-arrow-left", label: "Previous Step", onPress: prevStep, isDisabled: disablePrevStep }))),
                onLastStep ? (React.createElement(IconButton, Object.assign({}, commonButtonProps, { variant: "primary", iconName: "check", busy: isBusy, label: isBusy ? submitProcessing : submitButtonLabel, onPress: handleNextPress, isDisabled: disableSubmit }))) : (React.createElement(IconButton, Object.assign({}, commonButtonProps, { variant: "primary", iconSide: "end", iconName: "fa-arrow-right", label: "Next Step", onPress: handleNextPress, isDisabled: disableNextStep }, nextButtonProps))))),
        React.createElement(React.Fragment, null, children),
        React.createElement(ConfirmModal, { title: confirmCancel.title, message: confirmCancel.message, confirmText: confirmCancel.confirmText, rejectText: confirmCancel.rejectText, open: openCancelConfirm, clickOutsideHandler: () => setOpenCancelConfirm(false), responseHandler: handleCancelRequest })));
}
//# sourceMappingURL=Wizard.js.map